import { Document, Font, StyleSheet, Text, View } from "@react-pdf/renderer";
import PageLayout from "../Contract/contractPdf/contractService/PageLayout";
import ArabicRegular from "../../../../../src/assets/ArabicFont/IBMPlexSansArabic-Regular.ttf";

Font.register({
  family: "NotoSansArabic",
  src: ArabicRegular, // Ensure this path is correct
});

export default function Trigger({ data, clientDetails, valueChange, header }) {
  const translateToArabicNew = (text) => {
    const translations = {
      "Invoice details.": "تفاصيل الفاتـــــــــــــورة",
      "Invoice Date": "تاريخ اصدار الفاتورة",
      "Invoice no.": "رقم الفاتورة",
      "Invoice for": "فاتورة الخدمات المنفذة فى شهر",
      "Customer VAT Number": "الرقــم الضريبــى للعميل",
      "Contract Number #": "رقم العقد",
      "Taxable amount Service charges": "مبلغ خاضع للضريبة",
      "Non-Taxable Amount - SAR": "15قيمة الضريبة%",
      "VAT Amount 15% - SAR": "15قيمة الضريبة%",
      "Total Invoice Amount - SAR": "المبلغ الأجمالى للفاتورة",
      "VAT # for Soundlines Administrative Co.":
        "لرقم الضريبى لشركة ساوندلاينز الإداريه",
    };

    return translations[text] || text; // Return translated text or original if no translation is found
  };

  const styles = StyleSheet.create({
    page: {
      flexDirection: "column",
      backgroundColor: "#E4E4E4",
      padding: 20,
    },
    tableContainer: {
      marginTop: 10,
    },
    tableRow: {
      flexDirection: "row",
      borderTopWidth: 1, // Line on top of the row
      borderBottomWidth: 1, // Line on bottom of the row
      borderColor: "#000",
      borderStyle: "solid",
    },
    tableCell: {
      width: 30, // Fixed width of 30 for each cell
      padding: 8,
      fontSize: 10,
      borderRightWidth: 1, // Divider between cells
      borderColor: "#000",
    },
    firstCell: {
      borderLeftWidth: 1, // Divider on the left side of the first cell
      borderColor: "#000",
    },
    lastCell: {
      width: 30, // Fixed width for the last cell as well
      padding: 8,
      borderLeftWidth: 1, // Divider on the left side of the last cell
      borderRightWidth: 1, // Divider on the right side of the last cell
      borderColor: "#000",
    },
    arabicText: {
      fontFamily: "NotoSansArabic",
      textAlign: "right",
      direction: "rtl",
      fontSize: 9,
      margin: 5,
      textDecoration: "underline",
    },
    tableHeader: {
      fontWeight: "bold",
      fontSize: 12,
      padding: 10,
      textAlign: "center",
      borderBottomWidth: 1,
      borderBottomColor: "#000",
    },
  });

  return (
    <Document>
      <PageLayout size="A4">
        <View style={{ marginBottom: 10, alignItems: "center" }}>
          <Text
            style={{ fontSize: 15, fontWeight: "bold", textAlign: "center" }}
          >
            {header}
          </Text>
        </View>

        {/* Client details */}
        <View style={{ marginBottom: 10 }}>
          <Text style={{ fontSize: 12, fontWeight: "bold" }}>Customer:</Text>
        </View>
        <View style={{ marginBottom: 10 }}>
          <Text style={{ fontSize: 10, fontWeight: "bold" }}>
            To: {clientDetails && clientDetails[0]?.customer_name}
          </Text>
        </View>
        <View style={{ marginBottom: 10 }}>
          <Text style={{ fontSize: 10, fontWeight: "bold" }}>
            {clientDetails && clientDetails[0]?.company_registration}
          </Text>
        </View>
        <View style={{ marginBottom: 10 }}>
          <Text style={{ fontSize: 10, fontWeight: "bold" }}>
            {clientDetails && clientDetails[0]?.address}
          </Text>
        </View>
        <View style={{ marginBottom: 10 }}>
          <Text style={{ fontSize: 10, fontWeight: "bold" }}>
            {clientDetails && clientDetails[0]?.po_box}
          </Text>
        </View>
        <View style={{ marginBottom: 10 }}>
          <Text style={{ fontSize: 10, fontWeight: "bold" }}>
            {clientDetails && clientDetails[0]?.pincode}
          </Text>
        </View>

        {/* Invoice details */}
        <View style={{ marginBottom: 10, alignItems: "center" }}>
          <Text
            style={{ fontSize: 15, fontWeight: "bold", textAlign: "center" }}
          >
            INVOICE DETAILS
          </Text>
        </View>

        {/* Table */}
        <View style={styles.tableContainer}>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.firstCell]}>
              {"Invoice details"}
            </Text>
            <Text style={styles.tableCell}></Text>
            <Text style={styles.arabicText}>
              {" "}
              {translateToArabicNew("Invoice details.")}
            </Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.firstCell]}>
              {"Invoice Date"}
            </Text>
            <Text style={styles.tableCell}>01/09/2023</Text>
            <Text style={styles.arabicText}>
              {translateToArabicNew("Invoice Date")}
            </Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.firstCell]}>
              {"Invoice Date"}
            </Text>
            <Text style={styles.tableCell}>
              {new Date()
                .toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })
                .split(" ")
                .join("-")
                .toUpperCase()}
            </Text>
            <Text style={styles.arabicText}>
              {translateToArabicNew("Invoice Date")}
            </Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.firstCell]}>
              {"Invoice no."}
            </Text>
            <Text style={styles.tableCell}>{""}</Text>
            <Text style={styles.arabicText}>
              {translateToArabicNew("Invoice no.")}
            </Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.firstCell]}>
              {"Invoice for"}
            </Text>
            <Text style={styles.tableCell}>{""}</Text>
            <Text style={styles.arabicText}>
              {translateToArabicNew("Invoice for")}
            </Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.firstCell]}>
              {"Customer VAT Number"}
            </Text>
            <Text style={styles.tableCell}>{""}</Text>
            <Text style={styles.arabicText}>
              {translateToArabicNew("Customer VAT Number")}
            </Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.firstCell]}>
              {"Contract Number #"}
            </Text>
            <Text style={styles.tableCell}>{""}</Text>
            <Text style={styles.arabicText}>
              {translateToArabicNew("Contract Number #")}
            </Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.firstCell]}>
              {"Taxable amount Service charges"}
            </Text>
            <Text style={styles.tableCell}>{""}</Text>
            <Text style={styles.arabicText}>
              {translateToArabicNew("Taxable amount Service charges")}
            </Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.firstCell]}>
              {"Non-Taxable Amount - SAR"}
            </Text>
            <Text style={styles.tableCell}>{""}</Text>
            <Text style={styles.arabicText}>
              {translateToArabicNew("Non-Taxable Amount - SAR")}
            </Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.firstCell]}>
              {"VAT Amount 15% - SAR"}
            </Text>
            <Text style={styles.tableCell}>{""}</Text>
            <Text style={styles.arabicText}>
              {translateToArabicNew("VAT Amount 15% - SAR")}
            </Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.firstCell]}>
              {"Total Invoice Amount - SAR"}
            </Text>
            <Text style={styles.tableCell}>{""}</Text>
            <Text style={styles.arabicText}>
              {translateToArabicNew("Total Invoice Amount - SAR")}
            </Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.firstCell]}>
              {"VAT # for Soundlines Administrative Co."}
            </Text>
            <Text style={styles.tableCell}>{""}</Text>
            <Text style={styles.arabicText}>
              {translateToArabicNew("VAT # for Soundlines Administrative Co.")}
            </Text>
          </View>
        </View>

        {/* Footer */}
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-evenly",
            margin: 10,
          }}
        >
          <Text style={{ fontSize: 15, fontWeight: "bold", marginTop: 50 }}>
            Finance Dept.
          </Text>
          <Text style={{ fontSize: 15, fontWeight: "bold", marginTop: 50 }}>
            General Manager.
          </Text>
        </View>
      </PageLayout>
    </Document>
  );
}
